// extracted by mini-css-extract-plugin
module.exports = {"hover":"map_hover__3VWnA","control-panel":"map_control-panel__1GFtL"};